(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-us-noli"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.currentScript && document.currentScript.closest('.noli-about');
    if (!root) root = document.querySelector('.noli-about');
    if (!root) return;

    // Fade-up on intersect — adds the `.visible` class that the CSS targets.
    var els = root.querySelectorAll('.fade-up');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('visible');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -20px 0px' });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('visible'); });
    }

    // Safety: if anything is still hidden after 2s (e.g. observer didn't fire
    // because the section is taller than the viewport-tracker expects, or JS
    // ran too late), force everything visible.
    setTimeout(function () {
      root.querySelectorAll('.fade-up:not(.visible)').forEach(function (el) {
        el.classList.add('visible');
      });
    }, 2000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["depict-recommendations"] && !Shopify.designMode) return;
  try {
    (function () {
  function initSection(section) {
    var grid = section.querySelector('[data-depict-recs-grid]');
    if (!grid) return;
    var prev = section.querySelector('[data-depict-rec-prev]');
    var next = section.querySelector('[data-depict-rec-next]');
    if (!prev && !next) return;

    function update() {
      var atStart = grid.scrollLeft <= 1;
      var atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 1;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
    }
    function scrollPage(direction) {
      grid.scrollBy({ left: direction * grid.clientWidth * 0.9, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { scrollPage(-1); });
    if (next) next.addEventListener('click', function () { scrollPage(1); });
    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll(root) {
    (root || document).querySelectorAll('.depict-rec-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when this section is reloaded.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["edit-scroller"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('coated-edit-scroller')) {
    class CoatedEditScroller extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-ce-track]');
        this.prev = this.querySelector('[data-ce-prev]');
        this.next = this.querySelector('[data-ce-next]');
        if (!this.track) return;

        this._update = this.update.bind(this);
        this._onPrev = () => this.page(-1);
        this._onNext = () => this.page(1);

        this.track.addEventListener('scroll', this._update, { passive: true });
        if (this.prev) this.prev.addEventListener('click', this._onPrev);
        if (this.next) this.next.addEventListener('click', this._onNext);

        this._ro = new ResizeObserver(this._update);
        this._ro.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this._update);
        if (this.prev) this.prev.removeEventListener('click', this._onPrev);
        if (this.next) this.next.removeEventListener('click', this._onNext);
        if (this._ro) this._ro.disconnect();
      }

      page(direction) {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({
          left: direction * this.track.clientWidth * 0.85,
          behavior: reduce ? 'auto' : 'smooth'
        });
      }

      update() {
        const t = this.track;
        const max = t.scrollWidth - t.clientWidth;
        this.toggleAttribute('data-scrollable', max > 4);
        if (this.prev) this.prev.disabled = t.scrollLeft <= 2;
        if (this.next) this.next.disabled = t.scrollLeft >= max - 2;
      }
    }
    customElements.define('coated-edit-scroller', CoatedEditScroller);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-offer-bar"] && !Shopify.designMode) return;
  try {
    
    window.addEventListener('load', (event) => {
        const thisBar = document.querySelector('.shoplift-offer--bar--sticky');

        if (thisBar != null) {
            const thisHeader = document.querySelector('.shoplift-offerbar-wrapper');
            thisHeader.classList.add("shoplift-offer-bar-sticky");

            const mainHeader = document.querySelector('#shopify-section-header > sticky-header');

            const mainInitialTop = mainHeader.offsetTop;
            const stickyStart = mainHeader ? (mainHeader.offsetTop + mainHeader.clientHeight) : 0;
            let lastScroll = window.scrollY;
            document.addEventListener("scroll", (scrollEvent) => {
                if (!thisHeader) return;

                // Do it quick and dirty
                const mainHidden = mainHeader && (window.scrollY > lastScroll);
                lastScroll = window.scrollY;

                const makeSticky = window.pageYOffset > stickyStart || mainHeader && window.pageYOffset > mainInitialTop && mainHeader.parentElement.classList.contains("shopify-section-header-sticky");

                thisHeader.classList.toggle("shoplift-offer-bar-sticky", makeSticky);

                if (!makeSticky) return;

                let topPosition = 0;

                if (mainHeader && !mainHidden)
                    topPosition += mainHeader.clientHeight;

                thisHeader.style.top = topPosition + "px";
            });
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-shop-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticky-shop-bar')) {
    // "Shop ALL best-sellers!" -> "shopallbestsellers"
    var ssbNorm = function (str) { return String(str || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); };

    // The layer something REALLY sits on: if it is inside a wrapper that has its own
    // layer, the outermost wrapper's z-index is the one that counts against the page.
    var ssbEffectiveZ = function (el) {
      var found = null;
      for (var node = el; node && node !== document.body && node !== document.documentElement; node = node.parentElement) {
        var cs = getComputedStyle(node);
        var z = parseInt(cs.zIndex, 10);
        if (!isNaN(z) && cs.position !== 'static') found = z;
      }
      return found;
    };

    class StickyShopBar extends HTMLElement {
      connectedCallback() {
        this.bar = this.bar || this.querySelector('[data-ssb-bar]');
        if (!this.bar) return;
        this.visible = false;

        // Move the bar to the top level of the page. Inside a section it can be
        // trapped under later sections, whatever its z-index is.
        if (this.bar.parentNode !== document.body) document.body.appendChild(this.bar);

        this.keepBelowChat();

        // In the theme editor, keep the bar showing so it can be styled.
        if (window.Shopify && window.Shopify.designMode) {
          this.setVisible(true);
          return;
        }

        this.target = this.resolveTarget();

        // Checked once per frame while scrolling. Deliberately not an
        // IntersectionObserver: that only reports when something enters or leaves
        // the screen, so a fast fling or a jump past the button could be missed.
        this._ticking = false;
        this._check = function () {
          this._ticking = false;
          // Button missing, re-rendered or hidden (e.g. a desktop-only copy)? Look again.
          if (!this.target || !this.target.isConnected || this.target.getClientRects().length === 0) {
            this.target = this.resolveTarget();
          }
          if (!this.target) return; // nothing to measure against: stay hidden
          // Shown only while the shopper is BELOW the button: it has scrolled off the
          // top of the screen. Back in view, or anywhere above it, the bar is hidden.
          var passed = this.target.getBoundingClientRect().bottom <= 0;
          if (passed !== this.visible) this.setVisible(passed);
        }.bind(this);
        this._onScroll = function () {
          if (!this._ticking) {
            this._ticking = true;
            requestAnimationFrame(this._check);
          }
        }.bind(this);
        this._onResize = function () {
          this._check();
          this.setVisible(this.visible); // re-apply (desktop/mobile breakpoint may have changed)
        }.bind(this);
        this._onReady = function () {
          this.target = this.resolveTarget();
          this._check();
        }.bind(this);

        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onResize);
        // The button may not exist yet if this script runs before the page has finished loading.
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this._onReady);
        window.addEventListener('load', this._onReady);
        this._check(); // right away, in case the page loads already scrolled down
      }

      disconnectedCallback() {
        if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
        if (this._onResize) window.removeEventListener('resize', this._onResize);
        if (this._onReady) {
          document.removeEventListener('DOMContentLoaded', this._onReady);
          window.removeEventListener('load', this._onReady);
        }
        if (this._chatObserver) this._chatObserver.disconnect();
        (this._chatTimers || []).forEach(clearTimeout);
        window.removeEventListener('gorgias-widget-loaded', this._syncChat);
        // The bar lives on <body>, so remove it with the section (theme editor re-renders).
        if (this.bar && this.bar.parentNode === document.body) this.bar.remove();
        document.documentElement.classList.remove('ssb-active');
      }

      // Keeps the bar one layer BELOW the Gorgias chat (button, window and campaign
      // pop-ups), whatever layer Gorgias is using. The chat loads late, so this runs
      // when it announces itself, when it is added to the page, and on a few timers.
      keepBelowChat() {
        if (this.dataset.belowChat !== 'true') return;
        var bar = this.bar;
        var cap = parseInt(getComputedStyle(bar).getPropertyValue('--ssb-z'), 10) || 9000;

        this._syncChat = function () {
          var lowest = null;
          var frames = document.querySelectorAll('#gorgias-chat-container iframe');
          for (var i = 0; i < frames.length; i++) {
            var z = ssbEffectiveZ(frames[i]);
            if (z !== null && (lowest === null || z < lowest)) lowest = z;
          }
          if (lowest === null) return;                       // chat not on the page (yet), or no numeric layer
          bar.style.zIndex = String(Math.max(1, Math.min(cap, lowest - 1)));
        };

        window.addEventListener('gorgias-widget-loaded', this._syncChat);
        if ('MutationObserver' in window) {
          this._chatObserver = new MutationObserver(this._syncChat);
          this._chatObserver.observe(document.body, { childList: true });
        }
        this._chatTimers = [500, 1500, 4000, 10000].map(function (ms) { return setTimeout(this._syncChat, ms); }, this);
        this._syncChat();
      }

      // The in-page button if it can be found, otherwise the section directly above
      // this one (this section itself is collapsed, so it can't be measured).
      resolveTarget() {
        var found = this.findTarget();
        if (found) return found;
        var wrapper = this.closest('[id^="shopify-section-"]');
        var prev = wrapper ? wrapper.previousElementSibling : null;
        while (prev && prev.getClientRects().length === 0) prev = prev.previousElementSibling;
        return prev;
      }

      // 1. an explicit CSS selector, if one is set
      // 2. the first section whose ID contains the section hint, then its first matching button
      // 3. the first matching button anywhere on the page
      findTarget() {
        var bar = this.bar;
        var isUsable = function (el) { return el && el !== bar && !bar.contains(el) && el.getClientRects().length > 0; };

        var selector = (this.dataset.trigger || '').trim();
        if (selector) {
          try {
            var chosen = document.querySelector(selector);
            if (isUsable(chosen)) return chosen;
          } catch (e) { /* invalid selector: ignore */ }
        }

        var words = (this.dataset.triggerText || '').split(/\s+/).map(ssbNorm).filter(Boolean);
        if (!words.length) return null;
        var matchIn = function (root) {
          var nodes = root.querySelectorAll('a, button');
          for (var i = 0; i < nodes.length; i++) {
            var text = ssbNorm(nodes[i].textContent);
            var ok = words.every(function (w) { return text.indexOf(w) !== -1; });
            if (ok && isUsable(nodes[i])) return nodes[i];
          }
          return null;
        };

        var hint = ssbNorm(this.dataset.triggerSection);
        if (hint) {
          var sections = document.querySelectorAll('[id^="shopify-section-"]');
          for (var s = 0; s < sections.length; s++) {
            if (ssbNorm(sections[s].id).indexOf(hint) === -1) continue;
            var inSection = matchIn(sections[s]);
            if (inSection) return inSection;
          }
        }
        return matchIn(document);
      }

      setVisible(on) {
        this.visible = on;
        this.bar.classList.toggle('is-visible', on);
        if (this.dataset.keepClear === 'true') {
          var shown = on && getComputedStyle(this.bar).display !== 'none';
          document.documentElement.classList.toggle('ssb-active', shown);
        }
      }
    }
    customElements.define('sticky-shop-bar', StickyShopBar);
  }

  } catch(e) { console.error(e); }
})();
})();
